import { render, staticRenderFns } from "./MatchingStat.vue?vue&type=template&id=6e1ee8dd"
import script from "./MatchingStat.vue?vue&type=script&lang=js"
export * from "./MatchingStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports